module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('b-nav', {
    staticClass: "hidden-sm-down"
  }, [_c('b-nav-item', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('div', {
    staticClass: "icon icon-home"
  })]), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('editorial-board-dropdown'), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('publications-dropdown'), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/for-authors/submission-guidelines",
      "exact": ""
    }
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('about-dropdown'), _vm._v(" "), _c('div', {
    staticClass: "col d-flex justify-content-center ml-auto hidden-lg-down"
  }, [_c('search-field')], 1), _vm._v(" "), _c('div', {
    staticClass: "search-dropdown col"
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.search_collapse",
      modifiers: {
        "search_collapse": true
      }
    }],
    staticClass: "button-secondary"
  }, [_c('div', {
    staticClass: "icon icon-search"
  })])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "button-primary",
    attrs: {
      "id": "submit_btn"
    }
  }, [_vm._v("Submit Paper")]), _vm._v(" "), _c('b-collapse', {
    staticClass: "nav flex-column",
    attrs: {
      "is-nav": "",
      "id": "search_collapse"
    }
  }, [_c('search-field')], 1)], 1), _vm._v(" "), _c('b-navbar', {
    staticClass: "hidden-md-up",
    attrs: {
      "toggleable": "",
      "id": "navbar"
    }
  }, [_c('b-nav', {
    staticClass: "horizontal-nav"
  }, [_c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'editorialBoardMembers'
      }
    }
  }, [_vm._v("Editorial Board")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'issueDetail',
        params: {
          volumeId: 1,
          issueId: 1
        }
      }
    }
  }, [_vm._v("Current Issue")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'forAuthorsSubmissionGuidelines'
      }
    }
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "col-auto"
  }, [_c('b-nav-toggle', {
    staticClass: "mx-0 p-0",
    attrs: {
      "position": "static",
      "target": "nav_collapse"
    }
  })], 1)], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "nav flex-column",
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "#"
    }
  }, [_c('search-field')], 1), _vm._v(" "), _c('editorial-board-dropdown', {
    staticClass: "mobile"
  }), _vm._v(" "), _c('publications-dropdown', {
    staticClass: "mobile"
  }), _vm._v(" "), _c('b-nav-item', {
    staticClass: "mobile",
    attrs: {
      "to": "/for-authors/submission-guidelines",
      "exact": ""
    }
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('about-dropdown', {
    staticClass: "mobile"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6932450"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-nav/HeaderNavComponent.vue
// module id = 1481
// module chunks = 1